import { inject, Injectable } from '@angular/core';
import { environment } from '@app/environments/environment';
import { UtilService } from '@app/modules/shared/service/util.service';

export interface TenantConfig {
  id: string;
  code: string;
  name: string;
  logoUrl: string;
  faviconUrl: string;
  primaryColorPalette: Record<string, string>;
  secondaryColorPalette: Record<string, string>;
  recaptchaSiteKey: string;
}

@Injectable({
  providedIn: "root",
})
export class TenantService {

  private tenantId: string = "";
  private tenantName: string = "";
  private tenantCode: string = "";
  private tenantLogoUrl: string = "";
  private tenantFaviconUrl: string = "";
  private tenantPrimaryColorShades: Record<string, string> = {};
  private tenantSecondaryColorShades: Record<string, string> = {};
  private utilService = inject(UtilService);

  private CCMSLogoUrl: string = `${this.utilService.getNormalizedTenantCdnBaseUrl()}/assets/CardCentralLogo.png`;

  getTenantId(): string {
    return this.tenantId;
  }

  getTenantName(): string {
    return this.tenantName;
  }

  getTenantLogoUrl(): string {
    return this.tenantLogoUrl;
  }

  getTenantPrimaryColor(): string {
    // return this.tenantPrimaryColor;
    return this.tenantPrimaryColorShades[400]; // Default primary color
  }
  
  getTenantPrimaryColorShades(): Record<string, string> {
    return this.tenantPrimaryColorShades;
  }
  getTenantSecondaryColor() {
    return this.tenantSecondaryColorShades[400] || "#f7e4b6";
  }

  getTenantSecondaryColorShades(): Record<string, string> {
    return this.tenantSecondaryColorShades || {};
  }

  getCCMSLogoUrl(): string {
    return this.CCMSLogoUrl;
  }

  getTenantFaviconUrl(): string {
    return this.tenantFaviconUrl;
  }

  initTenant(tenantConfig: TenantConfig) {
    this.tenantId = tenantConfig.id;
    this.tenantCode = tenantConfig.code;
    this.tenantName = tenantConfig.name;
    this.tenantLogoUrl = `${environment.TENANT_CDN_BASE_URL}/assets/${tenantConfig.code}_logo.png` || `${tenantConfig.logoUrl}`;
    this.tenantPrimaryColorShades = tenantConfig.primaryColorPalette;
    this.tenantSecondaryColorShades = tenantConfig.secondaryColorPalette || {};
    this.tenantFaviconUrl = `${environment.TENANT_CDN_BASE_URL}/assets/${tenantConfig.code}_favicon.ico` || `${tenantConfig.faviconUrl}`;
  }
}
